import { Badge } from '@mantine/core';
import { useIntl } from 'react-intl';

import { freightStatusBadgeMessages } from './freight-status-badge-messages';

import type { AdlBadgeColors } from '../../../theme-v2/types';
import type { FreightShipmentStatus } from '../freight-details-types';
import type { MessageDescriptor } from 'react-intl';

type FreightStatusBadgeProps = {
  status: FreightShipmentStatus | null;
};

/** Maps a parsed status to its themed Badge color + label message. */
const STATUS_CONFIG: Record<FreightShipmentStatus, { color: AdlBadgeColors; message: MessageDescriptor }> = {
  Pending: { color: 'info', message: freightStatusBadgeMessages.pending },
  Booked: { color: 'info', message: freightStatusBadgeMessages.booked },
  InTransit: { color: 'info', message: freightStatusBadgeMessages.inTransit },
  Delivered: { color: 'active', message: freightStatusBadgeMessages.delivered },
  Exception: { color: 'alert', message: freightStatusBadgeMessages.exception },
  Quoted: { color: 'neutral', message: freightStatusBadgeMessages.quoted },
  Cancelled: { color: 'alert', message: freightStatusBadgeMessages.cancelled },
};

export const FreightStatusBadge = ({ status }: FreightStatusBadgeProps) => {
  const intl = useIntl();

  const config: { color: AdlBadgeColors; message: MessageDescriptor } = status
    ? STATUS_CONFIG[status]
    : { color: 'neutral', message: freightStatusBadgeMessages.unknown };

  return (
    <Badge color={config.color} data-testid='freight-status-badge' variant='dot'>
      {intl.formatMessage(config.message)}
    </Badge>
  );
};
